var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemovePeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.176,
    height: 43.765,
    viewBox: "0 0 41.176 43.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56411",
    "data-name": "Group 56411",
    transform: "translate(-1639.647 -229)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_690",
    "data-name": "Ellipse 690",
    cx: 12,
    cy: 11.5,
    rx: 12,
    ry: 11.5,
    transform: "translate(1648 229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85445",
    "data-name": "Path 85445",
    d: "M6.412,38.125H24.588A13.191,13.191,0,0,1,21.9,20.463a14.775,14.775,0,0,1-10-4.6A16.2,16.2,0,0,0,2,30.772v2.941A4.425,4.425,0,0,0,6.412,38.125Z",
    transform: "translate(1637.647 234.641)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55584",
    "data-name": "Group 55584",
    transform: "translate(1660.235 252.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55583",
    "data-name": "Group 55583",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85444",
    "data-name": "Path 85444",
    d: "M309.223,316.885a10.294,10.294,0,1,0,10.294,10.294A10.305,10.305,0,0,0,309.223,316.885Zm4.085,12.074h-8.17a1.78,1.78,0,1,1,0-3.56h8.17a1.78,1.78,0,1,1,0,3.56Z",
    transform: "translate(-298.929 -316.885)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePeople);
export default __webpack_public_path__ + "static/media/removePeople.b438ee1aa3fc038e01948fbd2bf1c7d1.svg";
export { ForwardRef as ReactComponent };